module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": 0,
      "multi-line": "",
      "color": _vm.snackbarType,
      "default": "",
      "bottom": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n  "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "text": "",
      "left": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.HIDE_SNACKBAR()
      }
    }
  }, [_vm._v("fechar")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4000f4a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-layouts/app-snackbar/snackbar.vue
// module id = 253
// module chunks = 0